
import type { PropType } from 'vue'
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        options: {
            type: Array as PropType<Array<Record<string, any>>>,
            default: () => []
        },
        value: {
            type: [String, Number, null, Array] as PropType<string | number | null | Array<string | number>>,
            default: null
        },
        displayBy: {
            type: String,
            default: 'name'
        },
        selectBy: {
            type: String,
            default: 'id'
        },
        canDeselect: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['update', 'reload'],
    setup(props, { emit }) {
        const isOptionSelected = (option: Record<string, any>) => {
            if (Array.isArray(props.value)) {
                if (props.value.length === 0) {
                    return false
                }

                return props.value.includes(option[props.selectBy])
            }

            if (props.value) {
                return props.value === option[props.selectBy]
            }

            return false
        }

        const onSelectOption = (option: Record<string, any>) => {
            if (isOptionSelected(option)) {
                if (props.canDeselect) {
                    if (Array.isArray(props.value)) {
                        const copy = [...props.value]
                        emit('update', copy.filter(o => o !== option[props.selectBy]))

                        return
                    } else {
                        emit('update', null)
                        return
                    }
                }

                return
            }

            if (Array.isArray(props.value)) {
                const copy = [...props.value]
                copy.push(option[props.selectBy])

                emit('update', copy)
                return
            }
            
            emit('update', option[props.selectBy])
        }

        return {
            isOptionSelected,
            onSelectOption
        }
    }
})
